import { render, staticRenderFns } from "./printBase.vue?vue&type=template&id=1b4c0844&scoped=true&"
import script from "./printBase.vue?vue&type=script&lang=js&"
export * from "./printBase.vue?vue&type=script&lang=js&"
import style0 from "./printBase.vue?vue&type=style&index=0&id=1b4c0844&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c0844",
  null
  
)

export default component.exports